export const Experiences = axios => ({

  save (slug, payload) {
    return axios.post(`/v1/profiles/${slug}/experiences`, payload)
  },

  list (slug) {
    return axios.get(`/v1/profiles/${slug}/experiences`)
  },

  get (slug, experienceSlug) {
    return axios.get(`/v1/profiles/${slug}/experiences/${experienceSlug}`)
  },

  update (slug, experienceSlug, payload) {
    return axios.put(`/v1/profiles/${slug}/experiences/${experienceSlug}`, payload)
  },

  delete (slug, experienceSlug) {
    return axios.delete(`/v1/profiles/${slug}/experiences/${experienceSlug}`)
  },

  sort (slug, experienceSlug, index) {
    return axios.patch(`/v1/profiles/${slug}/experiences/${experienceSlug}/move`, { sort_index: index })
  }
})
